import doNowTray from "./img/donow.png";
import replyLaterTray from "./img/replylater.png";
import archiveTray from "./img/archive.png";
import ignoreTray from "./img/ignore.png";

export const STAGE1_INBOX_CATEGORIES = [
  {
    id: "action_now",
    label: "Action Now",
    shortLabel: "DO NOW",
    trayImg: doNowTray,
    color: "#dc2626",
  },
  {
    id: "reply_later",
    label: "Reply Later",
    shortLabel: "REPLY LATER",
    trayImg: replyLaterTray,
    color: "#2563eb",
  },
  {
    id: "archive",
    label: "Archive",
    shortLabel: "ARCHIVE",
    trayImg: archiveTray,
    color: "#16a34a",
  },
  {
    id: "ignore",
    label: "Ignore",
    shortLabel: "IGNORE",
    trayImg: ignoreTray,
    color: "#64748b",
  },
];

export const STAGE1_INBOX_EMAILS = [
  {
    id: "server_down",
    subject: "Server is down!",
    sender: "IT Support",
    time: "9:15 AM",
    icon: "❗",
    iconBg: "#fee2e2",
    correctCategory: "action_now",
  },
  {
    id: "team_meeting",
    subject: "Team Meeting",
    sender: "Sarah Johnson",
    time: "10:30 AM",
    icon: "📅",
    iconBg: "#dcfce7",
    correctCategory: "reply_later",
  },
  {
    id: "q2_report",
    subject: "Q2 Report Review",
    sender: "Michael Brown",
    time: "11:00 AM",
    icon: "📊",
    iconBg: "#dbeafe",
    correctCategory: "action_now",
  },
  {
    id: "office_party",
    subject: "Office Party Invite",
    sender: "HR Team",
    time: "12:45 PM",
    icon: "🎉",
    iconBg: "#fce7f3",
    correctCategory: "reply_later",
  },
  {
    id: "invoice",
    subject: "Invoice #INV-2048",
    sender: "Finance Dept.",
    time: "1:30 PM",
    icon: "💰",
    iconBg: "#fef9c3",
    correctCategory: "action_now",
  },
  {
    id: "newsletter",
    subject: "Marketing Newsletter",
    sender: "Promo@newsletter.com",
    time: "2:15 PM",
    icon: "📰",
    iconBg: "#e0e7ff",
    correctCategory: "ignore",
  },
  {
    id: "lunch_weekend",
    subject: "Lunch this weekend?",
    sender: "Alex Thompson",
    time: "3:00 PM",
    icon: "🍽️",
    iconBg: "#ffedd5",
    correctCategory: "reply_later",
  },
  {
    id: "client_update",
    subject: "Urgent: Client Update",
    sender: "David Wilson",
    time: "3:45 PM",
    icon: "⚡",
    iconBg: "#fee2e2",
    correctCategory: "action_now",
  },
  {
    id: "weekly_digest",
    subject: "Weekly Status Digest",
    sender: "Project Team",
    time: "8:45 AM",
    icon: "📋",
    iconBg: "#f1f5f9",
    correctCategory: "archive",
  },
  {
    id: "flash_sale",
    subject: "Flash Sale — 50% Off",
    sender: "shop@retail.com",
    time: "4:00 PM",
    icon: "🏷️",
    iconBg: "#f3f4f6",
    correctCategory: "ignore",
  },
];

export const STAGE1_INBOX_PUZZLE_POINTS = 100;

export function getInboxCategoryLabel(categoryId) {
  const cat = STAGE1_INBOX_CATEGORIES.find((c) => c.id === categoryId);
  return cat ? cat.label : categoryId;
}

export function validateInboxTriage(assignments) {
  const misplaced = STAGE1_INBOX_EMAILS.filter(
    (email) => assignments[email.id] !== email.correctCategory
  );
  return {
    valid: misplaced.length === 0,
    misplaced,
    allPlaced: STAGE1_INBOX_EMAILS.every((email) => assignments[email.id]),
  };
}
